enum MixPanelKeys {
  GET_QUOTE_PUBLIC_OPENED = 'Get Quote Public Opened',
  AUTHENTICATION_PAGE_VIEWED = 'Authentication page viewed',
  CARRIER_REGISTERED = 'Carrier Registered',
  LOGGED_IN = 'Logged in',
  COMPANY_COUNTRY_SELECTED = 'Carrier company country selected',
  USER_AGREEMENTS_COMPLETED = 'User agreements completed',
  ACTIVE_JOBS_VIEWED = 'Active jobs viewed',
  PAST_JOBS_VIEWED = 'Past jobs viewed',
  POD_UPLOAD_INITIALIZED = 'POD upload initialized',
  DOCUMENT_UPLOADED = 'Document uploaded',
  CARRIER_COMPLETED_DOCUMENT_UPLOAD = 'Carrier completed document upload',
  ADD_INVOICE = 'Carrier viewed add invoice section on my payments tab',
  MY_INVOICES = 'Carrier viewed my invoice section on my payments tab',
  CARRIER_PICKED_COST = 'Carrier picked cost',
  CARRIER_CLICKED_ADD_INVOICE = 'Carrier clicked add invoice button',
  CARRIER_UPLOADED_INVOICE = 'Carrier uploaded invoice',
  // New keys
  LOGIN_PAGE_VIEWED = 'Login Page Viewed',
  LOGIN_METHOD_CHANGED = 'Login Method Changed',
  LOGIN_ERROR = 'Login Error',
  OTP_CONFIRMED = 'OTP Confirmed',
  OTP_ERROR = 'OTP Error',
  OTP_RESENT = 'OTP Resent',
  OTP_RESENT_ERROR = 'OTP Resent Error',
  FORGOT_PASSWORD_CLICKED = 'Forgot Password Clicked',
  REFRESH_PASSWORD_CLICKED = 'Refresh Password Clicked',
  REGISTER = 'Register',
  REGISTER_PAGE_VIEWED = 'Register Page Viewed',
  REGISTER_ERROR = 'Register Error',
  REGISTER_METHOD_CHANGED = 'Register Method Changed',
  PASSWORD_CREATED = 'Password Created',
  LOGIN = 'Login',
  // Bidding Feature
  LOAD_LIST_VIEWED = 'Load List Viewed',
  BID_NOW_CLICKED = 'Bid Now Clicked',
  PLACE_A_BID = 'Placed a Bid',
  BID_ERROR = 'Bid Error',
  UPDATED_BID = 'Updated Bid',
  UPDATED_BID_ERROR = 'Updated Bid Error',
  APPLIED_TO_JOB = 'Applied to Job',
  APPLIED_TO_JOB_ERROR = 'Applied to Job Error',
}

export default MixPanelKeys
